import { Component, OnInit } from '@angular/core';
import { ListDocument, Document, Any } from 'src/app/shared/models/signature.model';
import { DocumentBehaviorService } from 'src/app/services/behavior/document-behavior.service';
import { VerifySignatureBehaviorService } from 'src/app/services/behavior/verify-signature-behavior.service';
import { SignatureService } from 'src/app/services/signature-service/signature.service';
import { BaseComponent } from '../../components/base-component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends BaseComponent implements OnInit {

  signature:boolean = false;
  uploadFile:boolean = false;
  associateSubscriber:boolean = false;
  listDocuments:boolean = true;

  title:string = 'Documents';
  
  data: ListDocument = {"dto":[]};
  imagePath!: any;

  constructor(
    private readonly signatureService: SignatureService,
    private readonly documentService: DocumentBehaviorService,
    private readonly verifySignature: VerifySignatureBehaviorService
  ) {
    super();
  }

  ableDisable(listDocuments:boolean, uploadFile:boolean, associateSubscriber:boolean){
    if(listDocuments) {
      this.title = 'Documents'
    } else if(uploadFile) {
      this.title = 'Upload File'
    } else {
      this.title = 'Associete Subscriber'
    }
    this.listDocuments = listDocuments;
    this.uploadFile = uploadFile;
    this.associateSubscriber = associateSubscriber;
  }

  downloadFile(uid:string, type:string){
    this.signatureService.download(uid, type).subscribe((res:Any) => {
      const link = document.createElement("a");
      link.href = `data:application/pdf;base64,${res.dto}`;
      var birthday = new Date();
      link.download = birthday.getTime() + '_' + 'signature.pdf'
      link.click();
    })
  }

  getSignatureSubscriber(uid:string) {
    this.signatureService.getSignatureSubscriber(uid).subscribe((res:Any) => {
      this.imagePath = `data:image/png;base64,${res.dto}`;
    })
  }

  recendEmail(uidSigner:string, uidDoc:string){
    this.signatureService.recendEmail(uidSigner, uidDoc).subscribe();
  }

  settings(doc:Document) {
    this.verifySignature.setData(doc)
  }

  ngOnInit(): void {
    this.documentService.getListDocuments()
    this.documentService.data.subscribe(data => this.data = data)
  }

}